/**
 * HELPER DE PERMISSÕES
 * Verifica se o usuário tem acesso a determinado módulo ou ação
 */

class PermissionHelper {
  
  /**
   * Obtém os dados do usuário logado do sessionStorage
   */
  static getUsuario() {
    try {
      // Buscar pela chave correta: 'erp_user_session'
      const sessionData = sessionStorage.getItem('erp_user_session');
      if (!sessionData) {
        console.warn('⚠️ Nenhuma sessão encontrada em erp_user_session');
        return null;
      }
      
      const session = JSON.parse(sessionData);
      console.log('🔍 Dados da sessão:', session);
      
      // Os dados estão diretamente no session, não em session.userData
      return session;
    } catch (error) {
      console.error('❌ Erro ao obter dados do usuário:', error);
      return null;
    }
  }

  /**
   * Verifica se o usuário tem permissão para um módulo específico
   */
  static temPermissao(modulo) {
    const usuario = this.getUsuario();
    if (!usuario || !usuario.permissoes) return false;

    const papel = usuario.permissoes.papel;
    const modulos = usuario.permissoes.modulos || [];

    // DEV_ADMIN tem acesso total
    if (papel === 'DEV_ADMIN' || modulos.includes('*')) {
      return true;
    }

    // Verifica se o módulo está na lista
    return modulos.includes(modulo);
  }

  /**
   * Verifica se o usuário pode EDITAR/DELETAR (não é apenas visualizador)
   */
  static podeEditar() {
    const usuario = this.getUsuario();
    if (!usuario || !usuario.permissoes) return false;

    const papel = usuario.permissoes.papel;
    
    // Papéis que PODEM editar
    const papeisComEdicao = [
      'DEV_ADMIN',
      'DIRETOR',
      'LICITACAO_FULL',
      'COMPRAS_FULL',
      'FINANCEIRO_FULL',
      'OPERACIONAL_FULL',
      'TREINAMENTOS_FULL',
      'adm-full',
      'licitacao-full',
      'compras-full',
      'operacional-full',
      'treinamentos-full',
      'controladoria-full'
    ];

    return papeisComEdicao.includes(papel);
  }

  /**
   * Verifica se o usuário pode APENAS VISUALIZAR
   */
  static somenteVisualizacao() {
    const usuario = this.getUsuario();
    if (!usuario || !usuario.permissoes) return true; // Por segurança, bloqueia

    const papel = usuario.permissoes.papel;
    return papel === 'VISUALIZADOR';
  }

  /**
   * Obtém o papel do usuário
   */
  static getPapel() {
    const usuario = this.getUsuario();
    console.log('🔍 getPapel - Usuário:', usuario);
    console.log('🔍 getPapel - Permissões:', usuario?.permissoes);
    console.log('🔍 getPapel - Papel:', usuario?.permissoes?.papel);
    
    const papel = usuario?.permissoes?.papel || 'VISUALIZADOR';
    console.log('🎯 getPapel - Papel final:', papel);
    return papel;
  }

  /**
   * Verifica se é usuário de Compras
   */
  static isCompras() {
    const papel = this.getPapel();
    return papel === 'COMPRAS_FULL';
  }

  /**
   * Verifica se é usuário de Licitação
   */
  static isLicitacao() {
    const papel = this.getPapel();
    return papel === 'LICITACAO_FULL' || papel === 'licitacao-full';
  }

  /**
   * Verifica se é usuário de Operacional
   */
  static isOperacional() {
    const papel = this.getPapel();
    return papel === 'OPERACIONAL_FULL' || papel === 'operacional-full';
  }

  /**
   * Verifica se é usuário de Treinamentos
   */
  static isTreinamentos() {
    const papel = this.getPapel();
    return papel === 'TREINAMENTOS_FULL' || papel === 'treinamentos-full';
  }

  /**
   * Verifica se é administrador
   */
  static isAdmin() {
    const papel = this.getPapel();
    return papel === 'DEV_ADMIN' || papel === 'DIRETOR' || papel === 'adm-full';
  }

  /**
   * Verifica se tem permissão ADM-FULL (pode gerenciar tarefas, permissões, etc)
   */
  static isAdmFull() {
    const papel = this.getPapel();
    return papel === 'DEV_ADMIN' || papel === 'adm-full';
  }
}

export default PermissionHelper;
